import { History } from "history";
import qs from "qs";

import { SearchServiceUtils } from "@common/_services/searchutils.service";
import { SearchOptions } from "@pro/_services/models";

export class SearchService {
    getEmptySearchOptions: ()=>SearchOptions;
    doSearch: (GeneralSearchOptions)=>void;
    history: History;

    constructor(getEmptySearchOptions, doSearch, history) {
        this.getEmptySearchOptions = getEmptySearchOptions;
        this.doSearch = doSearch;
        this.history = history;
    }

    updateUrl(options:SearchOptions, location?) {
        const params = SearchServiceUtils.searchOptionsToQueryParams(options);
        this.history.push({ ...location, search: qs.stringify(params) });
    }

    updateFromUrl(location:any) {
        const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });
        const emptyOptions = this.getEmptySearchOptions();
        const options = SearchServiceUtils.queryParamsToSearchOptions(queryParams, emptyOptions);
        this.doSearch(options);
    }
}

